import { ErrorWrapper, ResponseWrapper } from "./util";
import { RoomBaseApiService } from "@/core/service/room.baseapi.service";

class RoomTranslationService extends RoomBaseApiService {
  async translationText(data) {
    try {
      const response = await this.request().post(
        `/api/v3/room/${this.getRoomId()}/translation`,
        data
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}

export const roomTranslationService = new RoomTranslationService();
